import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React from 'react';
import { Button } from '@/components/ui/button';
import { RotateCcw, ExternalLink } from 'lucide-react';

interface PlaylistCompletionScreenProps {
  playlistName: string;
  onRestart: () => void;
  externalButton?: { text: string; url: string };
  theme: 'purple' | 'blue' | 'dark' | 'white';
}

const themeColors = {
  purple: 'bg-[#7A5CFF] hover:bg-[#6A4CFF]',
  blue: 'bg-[#2D6CF6] hover:bg-[#1D5CE6]',
  dark: 'bg-white hover:bg-gray-100 text-black',
  white: 'bg-[#7A5CFF] hover:bg-[#6A4CFF]',
};

export const PlaylistCompletionScreen: React.FC<PlaylistCompletionScreenProps> = ({
  playlistName,
  onRestart,
  externalButton,
  theme
}) => {
  useLanguage();
  return (
    <div className="fixed inset-0 bg-background/95 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-card rounded-xl shadow-lg p-8 text-center space-y-6">
        <div className="space-y-2">
          <div className="text-6xl mb-4">🎉</div>
          <h2 className="text-2xl font-bold">{translateInterfaceText("Parabéns!")}</h2>
          <p className="text-muted-foreground">
            {translateInterfaceText("Você concluiu toda a playlist \"")}{playlistName}"
          </p>
        </div>
        
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button
            variant="outline"
            onClick={onRestart}
            className="w-full sm:w-auto"
          >
            <RotateCcw className="w-4 h-4 mr-2" />
            {translateInterfaceText("Assistir Novamente")}</Button>
          
          {externalButton && (
            <Button
              className={`w-full sm:w-auto ${themeColors[theme]}`}
              onClick={() => window.open(externalButton.url, '_blank')}
            >
              {externalButton.text}
              <ExternalLink className="w-4 h-4 ml-2" />
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};
